import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ToastMessage, type } from "@/lib/toastr";
import { changeRole } from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2, UserPlus } from "lucide-react";
import { useForm } from "react-hook-form";

const ChangeRole = ({ name, id, handleDialogItemOpenChange }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data) => await changeRole(id, data),
    mutationKey: ["changeRole"],
    onSuccess: (res) => {
      queryClient.invalidateQueries("teams");
      ToastMessage(type.SUCCESS, "Team member role changed successfully");
      handleDialogItemOpenChange(false);
    },
    onError: (err) => {
      handleDialogItemOpenChange(false);
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();

  const onSubmit = async (formData) => {
    await mutation.mutate(formData);
  };
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-8">
          <DialogHeader className="flex flex-row  w-full p-0 items-center gap-4 bg-off-white-1 py-6 px-8 rounded-t-[16px]">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-off-white-3">
              <UserPlus />
            </div>
            <div className="flex flex-col ">
              <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                Reassign Role to Team Member
              </DialogTitle>
              <DialogDescription className="text-sm">
                Reassign a role to an existing team member
              </DialogDescription>
            </div>
          </DialogHeader>
          <div className="flex flex-col gap-4 px-8 pb-8">
            <Input className="text-xs" value={name?.toString()} disabled />

            <FormField
              control={form.control}
              name="roleId"
              render={({ field }) => {
                return (
                  <FormItem>
                    <div className="flex flex-col w-full items-star  gap-1.5 border-[1px]  rounded-[8px] px-2 py-2  border-input-border ">
                      <FormLabel htmlFor="role" className="text-xs">
                        Role
                      </FormLabel>
                      <Select
                        value={field.value}
                        onValueChange={field.onChange}
                      >
                        <FormControl>
                          <SelectTrigger className="p-0 border-none">
                            <SelectValue placeholder="Select a role " />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <SelectItem value="merchant-admin">Admin</SelectItem>
                          <SelectItem value="merchant-developer">
                            Developer
                          </SelectItem>
                          <SelectItem value="merchant-staff">Staff</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </FormItem>
                );
              }}
            />
          </div>
        </div>
        <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
          <DialogClose asChild>
            <Button
              type="button"
              variant="ghost"
              className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
            >
              <ChevronLeft /> Cancel
            </Button>
          </DialogClose>
          <Button
            type="submit"
            className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
            disabled={
              !form.formState.isDirty ||
              !form.formState.isValid ||
              form.formState.isSubmitting
            }
          >
            {form.formState.isSubmitting && (
              <Loader2 className="text-white animate-spin" />
            )}
            Assign Role <ChevronRight />
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};

export default ChangeRole;
